import React, {useState , useEffect} from 'react'
import { Link } from 'react-router-dom';
import { FaBars } from 'react-icons/fa';
import { motion } from 'framer-motion';
import logo from '../../Assets/logo.png';
import './Navbar.css'
// import Aos from 'aos';
// 

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [showCourses, setShowCourses] = useState(false);
  const [showMenu, setShowMenu] = useState(false);

  const handleScroll = () => {
    const offset = window.scrollY;
    setScrolled(offset > 50);
  };


  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
   <>
    <nav className={`navbar container-fluid ${scrolled ? 'scrolled' : ''}`}>
        <div className="logo text-center mb-4">
          <img src={logo} alt="Logo" className='mb-3'  />
        </div>
        <div className="menu-icon" onClick={() => setShowMenu(!showMenu)}>
          <FaBars />
        </div>
        <ul className={`nav-links ${showMenu ? 'active' : ''}`}>
          <li className='li'><Link to="/">Home</Link></li>
          <li className='li'><Link to="/about">About</Link></li>
          <li className='li'><Link to="/pricing">Pricing</Link></li>

          <li className='li'
            onMouseEnter={() => setShowCourses(true)}
            onMouseLeave={() => setShowCourses(false)}
          >
            <Link >Courses</Link>
            {showCourses && (
              <ul className="dropdown">
                {/* <li><Link to="/courses/course1">Course 1</Link></li>
                <li><Link to="/courses/course2">Course 2</Link></li>
                <li><Link to="/courses/course3">Course 3</Link></li> */}
                <li><Link className="dropdown-item" to='/Noorani-Qaida'>Noorani Qaida</Link></li>
                  <li><Link className="dropdown-item" to='/OnlineQuranRecitation'>Online Quran Recitation Course</Link></li>
                 
                   <li><Link className="dropdown-item" to='/Online-Quran-Memorization'>Online Quran Memorization</Link></li>

                   <li><Link className="dropdown-item" to='/Tafseer'> Online Quran Tafseer</Link></li>
                  <li><Link className="dropdown-item" to='/Quran-with-Tajweed'> Quran with Tajweed</Link></li>
                  <li><Link className="dropdown-item" to='/Quran-Translation'>Online Quran Translation</Link></li>
              </ul>
            )}
          </li>
          <li  className='li'><Link to="/contact">Contact Us</Link></li>
          
          <li className=' '>
            <Link to="/OnlineRegistration" >
          <motion.button 
          className="contact-button " 
          whileHover={{ scale: 1.1 }} 
          whileTap={{ scale: 0.9 }}
        >
         Online Registration
        </motion.button>
        </Link>

          </li>
        </ul>
       
       
      </nav>
   
   
   
   
   
   </>
  )
}

export default Navbar
